import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mapResponseData: [],
  mainResponseData: [],
};

const chatbotDataSlice = createSlice({
  name: 'chatbotData',
  initialState,
  reducers: {
    setMapResponseData(state, action) {
      const { question, solution } = action.payload;
      const newData = { question, solution };
      
      // Check if the new data already exists
      const existingIndex = state.mapResponseData.findIndex(data => data.question === question && data.solution === solution);
      
      // If data already exists, remove it
      if (existingIndex !== -1) {
        state.mapResponseData.splice(existingIndex, 1);
      }

      // Add new data
      state.mapResponseData.push(newData);

      // Limit array length to 10
      if (state.mapResponseData.length > 10) {
        state.mapResponseData.splice(0, state.mapResponseData.length - 10);
      }
    },
    setMainResponseData(state, action) {
      const { question, solution } = action.payload;
      const newData = { question, solution };

      // Check if the new data already exists
      const existingIndex = state.mainResponseData.findIndex(data => data.question === question && data.solution === solution);

      // If data already exists, remove it
      if (existingIndex !== -1) {
        state.mainResponseData.splice(existingIndex, 1);
      }

      // Add new data
      state.mainResponseData.push(newData);

      // Limit array length to 10
      if (state.mainResponseData.length > 10) {
        state.mainResponseData.splice(0, state.mainResponseData.length - 10);
      }
    },
    mergeState(state) {
      state.mainResponseData = [...state.mainResponseData, ...state.mapResponseData];
      state.mapResponseData = [];
    },
    resetChatbotData: () => initialState,
  },
});

const { reducer, actions } = chatbotDataSlice;

export const {
  resetChatbotData,
  setMapResponseData,
  setMainResponseData,
  mergeState
} = actions;
export default reducer;
